var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNitrogenRec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#18c60b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,2A28,28,0,1,1,2,30,28,28,0,0,1,30,2m0-2A30,30,0,1,0,60,30,30,30,0,0,0,30,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.33,53.5a1,1,0,0,1-1-1V7.5a1,1,0,0,1,1-1C43,6.5,55.83,17,55.83,30S43,53.5,32.33,53.5Zm1-45V51.46c9.47-.64,20.5-10.28,20.5-21.46S42.8,9.18,33.33,8.53Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 10,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 15,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 20,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 25,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 30,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 35,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 40,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 45,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.5,
    y: 50,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 7.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 12.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 17.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 22.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 27.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 32.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 37.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 42.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 35,
    y: 47.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 10,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 15,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 20,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 25,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 30,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 35,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 40,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.5,
    y: 45,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 12.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 17.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 22.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 27.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 32.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 37.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 42.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 40,
    y: 47.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 15,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 20,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 25,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 30,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 35,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 40,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.5,
    y: 45,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 17.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 22.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 27.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 32.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 37.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 45,
    y: 42.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.5,
    y: 20,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.5,
    y: 25,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.5,
    y: 30,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.5,
    y: 35,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47.5,
    y: 40,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 22.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 27.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 32.5,
    width: 2.5,
    height: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50,
    y: 37.5,
    width: 2.5,
    height: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitrogenRec);
export default __webpack_public_path__ + "static/media/nitrogenRec.9a3be30a339995a7db864b48062bad5b.svg";
export { ForwardRef as ReactComponent };